/*
 * @Description: 任务有礼
 * @Author: your name
 * @Date: 2021-08-05 19:04:22
 * @LastEditTime: 2021-08-11 17:24:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 */

import http from "@/plugin/axios";
// import { Apis } from '../index';

export default {
  /**
   * 任务list
   */
  getWxAppletTaskList: (data: any): Promise<any> => {
    return http.post("/activity/task/getWxAppletTaskList", data);
  },
  /**
   * 任务详情
   */
  getWxAppletTaskDetailList: (data: any): Promise<any> => {
    return http.post("/activity/task/getWxAppletTaskDetailList", data);
  },
  /**
   * 完成任务
   */
  completeTask: (data: any): Promise<any> => {
    return http.post("/activity/task/completeTask", data);
  },
  /**
   * 领取任务奖励
   */
  receiveTaskReward: (data: any): Promise<any> => {
    return http.post("/activity/task/receiveTaskReward", data);
  },
  /**
   * 是否绑定账号任务
   */
  bindingTask: (data: any): Promise<any> => {
    return http.post("/activity/task/bindingTask", data);
  },
  /**
   * 保存任务问卷
   */
  saveTaskQuestion: (data: any): Promise<any> => {
    return http.post("/activity/task/saveTaskQuestion", data);
  },
  /**
   * 礼物page
   */
  getWxAppletGiftPage: (data: any): Promise<any> => {
    return http.post("/activity/gift/getWxAppletGiftPage", data);
  },
  /**
   * 兑换礼物
   */
  getGiftExchange: (data: any): Promise<any> => {
    return http.post("/activity/gift/getGiftExchange", data);
  },
  /**
   * 礼物兑换记录
   */
  getGiftExchangePage: (data: any): Promise<any> => {
    return http.post("/activity/gift/getGiftExchangePage", data);
  },
  /**
   * 更新修改地址信息
   */
  updateGiftAddress: (data: any): Promise<any> => {
    return http.post("/activity/gift/updateGiftAddress", data);
  },

  /**
   * 区域等级查询
   */
  getAreaList: (data: any): Promise<any> => {
    return http.post("/question/region/getAreaList", data);
  },
  /**
   * 邀请用户二维码
   */
  getInviteQRCode: (data: any): Promise<any> => {
    return http.post("/activity/user/getInviteQRCode", data);
  },
  /**
   * 每日签到任务连续次数
   */
  getUserSignTask: (data: any): Promise<any> => {
    return http.post("/activity/task/getUserSignTask", data);
  },
  /**
   * 每日签到任务 每日签到
   */
  receiveSignTask: (data: any): Promise<any> => {
    return http.post("/activity/task/receiveSignTask", data);
  },
  /**
   * u币抽奖 用户金币奖品详情
   */
  getUserCoinDrawDetailPage: (data: any): Promise<any> => {
    return http.post("/activity/gift/getUserCoinDrawDetailPage", data);
  },
  /**
   * u币抽奖 领取奖品
   */
  getUseDrawDetail: (data: any): Promise<any> => {
    return http.post("/activity/gift/getUseDrawDetail", data);
  },
  /**
   * u币抽奖 获取当天已抽奖次数 和 用户的U币数量
   */
  getUserDrawCount: (data: any): Promise<any> => {
    return http.post("/activity/coinDraw/getUserDrawCount", data);
  },

  /**
   * u币抽奖 奖品
   */
  getDrawList: (data: any): Promise<any> => {
    return http.post("/activity/coinDraw/getDrawList", data);
  },

  /**
   * u币抽奖 用户抽奖
   */
  getUserDraw: (data: any): Promise<any> => {
    return http.post("/activity/coinDraw/getUserDraw", data);
  },
  /**
   * u币抽奖 礼物兑换个数
   */
  getGifCount: (data: any): Promise<any> => {
    return http.post("/activity/gift/getGifCount", data);
  },
};
